var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin"},[(!_vm.authReady)?_c('div',{staticClass:"admin__auth-loading"},[_c('div',{staticClass:"lds-dual-ring"})]):[(!_vm.authenticated)?_c('div',{staticClass:"ovelay"},[_c('Auth',{on:{"loggedIn":_vm.getLoginInfo}})],1):_vm._e(),(_vm.authenticated)?_c('router-view'):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }